/**
 * @fileoverview CSS module for rendering horizontal layout questions
 * Provides styles for horizontal layout containers, layout, and spacing
 *
 * @example
 * // Usage in component:
 * import styles from './HorizontalLayoutRenderer.module.css';
 *
 * <div className={styles.horizontalLayout}>
 *   <div className={styles.horizontalLayout_item}>
 *     <input className={styles.input} type="text" />
 *   </div>
 * </div>
 */

.horizontalLayout {
    display: flex;
    padding: 0;
    margin: 0;
    width: 100%;
    flex-direction: column;
    justify-content: space-between;
    gap: 1rem;
    border: none;
}

.horizontalLayout_item {
    flex: 1;
}

@media (min-width: 768px) {
    .horizontalLayout {
        flex-direction: row;
    }
}
